





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TAcquisition, TPatient } from '@/plugins/podolib/services/entities/EntityPatients';

@Component
export default class PatientAcquisitionExportationFramePatient extends Vue {
  @Prop({ required: true }) private patient!: TEntity<TPatient>;
  @Prop({ required: true }) private acquisition!: TEntity<TAcquisition>;

  get age() {
    return this.$moment().diff(this.$moment(this.patient!.infos.birthDate), 'years');
  }

  get gender() {
    return this.$t(
      this.patient!.infos.gender.toString() === '1' ? 'commons.standards.male' : 'commons.standards.female',
    );
  }
}
